import { motion } from 'framer-motion';
import { ChevronRight, Crown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../../context/ThemeContext';

const PricingCallToAction = () => {
  const navigate = useNavigate();
  const { isDarkTheme } = useTheme();

  return (
    <motion.section 
      id="pricing-cta"
      className={`py-40 px-4 ${
        isDarkTheme 
          ? 'bg-gradient-to-r from-black/90 to-black/80' 
          : 'bg-gradient-to-l from-amber-300/60 to-amber-500'
      }`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="max-w-7xl mx-auto text-center">
        {/* Floating Elements */}
        <div className={`absolute right-0 top-0 w-32 h-32 ${
          isDarkTheme 
            ? 'bg-amber-900/10' 
            : 'bg-amber-700/10'
        } blur-3xl animate-float`} />
        <div className={`absolute left-0 bottom-0 w-40 h-40 ${
          isDarkTheme 
            ? 'bg-amber-900/10' 
            : 'bg-amber-700/10'
        } blur-3xl animate-float-delayed`} />

        {/* Content */}
        <motion.div
          className="relative z-10"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
        >
          <h2 className={`text-3xl lg:text-4xl font-bold mb-6 ${
            isDarkTheme 
              ? 'text-amber-400' 
              : 'text-white'
          }`}>
            Unlock Premium Features
          </h2>
          
          <p className={`max-w-2xl mx-auto text-lg mb-8 ${
            isDarkTheme 
              ? 'text-gray-300' 
              : 'text-white/90'
          }`}>
            Get access to advanced analytics, priority support, and unlimited queries with our premium plans.
          </p>

          <motion.button
            onClick={() => navigate('/pricing')}
            className={`px-8 py-4 rounded-xl font-semibold transition-all flex items-center justify-center gap-3 mx-auto ${
              isDarkTheme 
                ? 'bg-gradient-to-r from-amber-700 to-amber-900 text-amber-100 hover:from-amber-600 hover:to-amber-800' 
                : 'bg-gradient-to-r from-amber-400 to-amber-600 text-white hover:from-amber-500 hover:to-amber-700'
            } shadow-lg hover:shadow-xl`}
            whileHover={{ 
              scale: 1.05,
              boxShadow: isDarkTheme 
                ? '0 10px 25px -5px rgba(180, 83, 9, 0.4)' 
                : '0 10px 25px -5px rgba(245, 158, 11, 0.4)'
            }}
            whileTap={{ scale: 0.98 }}
          >
            <Crown className="w-5 h-5" />
            <span>Upgrade Your Plan</span>
            <ChevronRight className="w-5 h-5" />
          </motion.button>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default PricingCallToAction;